export default function handleUserSelection(
  value,
  answer,
  answers,
  questions,
  setAnswers
) {
  const questionsSlice = questions.slice();

  const updatedAnswers = answers.slice(0);

  const isValidAnswer = answer.q_validation_func(value, answers);

  if (isValidAnswer) {
    const targetAnswer = updatedAnswers.filter((updatedAnswer) => {
      return updatedAnswer.q_id === answer.q_id;
    })[0];

    // save users answer
    targetAnswer.a_string = value;

    // reset error just in case
    targetAnswer.a_error = false;

    // determine if need to insert follow up questions
    // const next_q_id = answer.q_next_step_func(targetAnswer, answers);
    const next_q_id = answer.q_next_step_func(answer, answers, questions);

    const q_ids = updatedAnswers.map((answer) => {
      return answer.q_id;
    });

    // NEXT QUESTION is always next in position
    // NOT like before when it was based on length of q_id
    // this was limiting in terms of folding questions of the tree back
    // and allowing the tree to merge back to left most path
    const posOfNextQuestion =
      updatedAnswers
        .map((updatedAnswer) => {
          return updatedAnswer.q_id;
        })
        .indexOf(answer.q_id) + 1;

    const nextPotentialQuestion = updatedAnswers[posOfNextQuestion];

    if (
      next_q_id &&
      nextPotentialQuestion &&
      nextPotentialQuestion?.q_id !== next_q_id
    ) {
      // OFF LEFT MOST PATH
      const newNextQuestion = questionsSlice.filter((question) => {
        return question.q_id === next_q_id;
      })[0];

      // LEAF, remove all subsequent questions from answers
      if (newNextQuestion.node_type === "leaf") {
        // if a LEAF never delete anything (like slice)
        // instead add hidden property
        for (let i = posOfNextQuestion; i < updatedAnswers.length; i++) {
          updatedAnswers[i].node_visibility = "hidden";
        }
      } else {
        // NODE, make sure subsequent questions are prents
        // need to make left most path starting from next questions's id.
        let leftMostPathFromCurrentNode = [];
        let deeperNextQuestion = newNextQuestion;
        let deeperNextQuestionChildrenLength =
          deeperNextQuestion.q_child_nodes.length;
        const map_q_id = questionsSlice.map((question) => {
          return question.q_id;
        });

        while (deeperNextQuestionChildrenLength !== 0) {
          deeperNextQuestion =
            questions[
              map_q_id.indexOf(
                deeperNextQuestion.q_next_step_func(deeperNextQuestion, [], [])
              )
            ];

          if (deeperNextQuestion) {
            deeperNextQuestionChildrenLength =
              deeperNextQuestion.q_child_nodes.length;

            leftMostPathFromCurrentNode.push(deeperNextQuestion);
          } else {
            deeperNextQuestionChildrenLength = 0;
          }
        }

        const earlierQuestions = updatedAnswers.slice(0, posOfNextQuestion + 2);

        let counter = 0;
        for (
          let i = posOfNextQuestion + 1;
          i < leftMostPathFromCurrentNode.length + posOfNextQuestion + 1;
          i++
        ) {
          if (
            updatedAnswers[i]?.q_id === leftMostPathFromCurrentNode[counter]
          ) {
            //show the node
            // updatedAnswers[i].node_type = "node";
          } else {
            //or overwrite if different
            updatedAnswers[i] = leftMostPathFromCurrentNode[counter];
            // updatedAnswers[i].node_type = "node";
          }
          counter = counter + 1;
        }

        // make sure all nodes are re-updated
        // to have node_type be node so nothing is hidden
        // if people jump around
        for (let i = 0; i < updatedAnswers.length; i++) {
          if (updatedAnswers[i].node_type === "node") {
            updatedAnswers[i].node_visibility = "visible";
          }
        }
      }

      updatedAnswers[posOfNextQuestion] = questionsSlice.filter((question) => {
        return question.q_id === next_q_id;
      })[0];
      updatedAnswers[posOfNextQuestion].node_visibility = "visible";
    }

    setAnswers(updatedAnswers);
  } else {
    updatedAnswers.filter((updatedAnswer) => {
      return updatedAnswer.q_id === answer.q_id;
    })[0].a_error = true;

    setAnswers(updatedAnswers);
    return;
  }
}
